import React, { useState, useEffect } from "react";
import "./rolemanagement.scss";
import Sidebar from "../Sidebar";
import Header from "../../component/loaderComponent/Header/Header";
import { Image_Url } from "../../ImageUrl/ImageUrl";
import { useDispatch } from "react-redux";
import Loader from "../../component/loaderComponent/loaderComponent/Loader";
import { RoleNameListAction } from "../../actions/RoleAction";
import { useNavigate } from "react-router-dom";
import NoDataFound from "../../component/noDataComponent/NoDataFound";
import { encode } from "base-64";
import Pagination from "@mui/material/Pagination";
import { HiMenu, HiX } from "react-icons/hi";
import Stack from "@mui/material/Stack";
import { constant } from "../../constants/constant";
import useMobileView from "../../constants/useMobileView";


function RoleManagement() {
  const [count, setCount] = useState(1);
  const [page, setPage] = useState(1);
  const [isLoading, setLoading] = useState(false);
  const {  isSidebarOpen, toggleSidebar } = useMobileView();

  
  const [roleNames, setRoleNames] = useState([]);
  const [states, setStates] = useState({
    role: ""
  });
  const dispatch = useDispatch();
  const navigate = useNavigate();

  async function GetRoleNameData(pageNumber) {
    setLoading(true);
    var response = await dispatch(RoleNameListAction(states.role ? `?role=${states.role}&page_size=${constant.paginationCount}&page=${pageNumber}` : `?page_size=${constant.paginationCount}&page=${pageNumber}`));
    if (response?.status === 200) {
      setLoading(false);
      setRoleNames(response?.data?.results?.data);
      setCount(Math.ceil(response.data.count / constant.paginationCount))
      setpaginationListcount(response.data.count);
    } else if (response === undefined) {
      setLoading(false);
    }
  }

  const CreateRole = (evt) => {
    navigate('/createrole')
  }

  const UpdateRole = (id) => {
    navigate(`/editrole/${encode(id)}`)
  }

  const handleChange = (evt) => {
    const { name, value } = evt.target;

    setStates({
      ...states,
      [name]: value.replace(/^ +/gm, ""),
    });
  };



  useEffect(() => {
    if (!states.role) {
      GetRoleNameData(1)
    }
  }, [states.role]);

  

  const handlePageChange = (event, value) => {
    setPage(value);
    GetRoleNameData(value)
  };
  

  
  const [paginationListcount, setpaginationListcount] = useState(0);
  const startItem = roleNames?.length === 0 ? 0 : (page - 1) * constant.paginationCount + 1;
  const endItem = Math.min(page * constant.paginationCount, paginationListcount);

  return (
    <div className="role-management-container">
      <div className="role-management-right-sidebar">
        <Header title="Role Management" />
        {isLoading ? (
          <Loader />
        ) : (
          <div className="role-management-first-collumn">
            <div className="role-managements">
              <div className="role-management">
                <label className="label-role-management">Role</label>
                <input type="search" className="text-filed-dropdown-role-management" name="role" value={states.role} onChange={handleChange} />
                <button
                  type="button"
                  className="search-button"
                  disabled={!states.role}
                  onClick={() => GetRoleNameData(1)}
                >
                  Search
                </button>
              </div>
              <div className="role-button-adds">
                <button
                  type="button"
                  className="create-role-management"
                  onClick={CreateRole}
                >
                  Create Role +
                </button>
              </div>
            </div>
            {roleNames?.length > 0 ?
              <div className="table-data">

                <table className="table">
                  <tr className="tablesth">
                    <th>Role Name</th>
                    <th>Action</th>
                  </tr>
                  {roleNames.map((data, index) => (
                    <tr className="tabletd">
                      <td>{data?.role}</td>
                      <td className="tabletdV">
                        {data.role !== "super_admin" && (
                          <div className="edit-icons">
                            <img
                              src={Image_Url.EDIT}
                              className="editicons"
                              onClick={() => UpdateRole(data?.id)}
                            />
                          </div>
                        )}
                      </td>
                    </tr>
                  ))}
                </table>
                
              </div>
              : <NoDataFound />}
              <div className="Pagination_section">
                  <Stack spacing={2}>
                    <Pagination
                      count={count}
                      className="pagination"
                      page={page}
                      size="medium"
                      defaultPage={1}
                      color="primary"
                      onChange={handlePageChange}
                    />
                  </Stack>
                  <div className="count">
                  <b>
                    <span>Displaying {startItem} to {endItem} out of {paginationListcount}</span>
                    </b>
                  </div>
                </div>
          </div>
          
        )}
        
      </div>
    </div>
  );
}

export default RoleManagement;